module.exports = __webpack_public_path__ + "img/badge_02.d4c8ba4c.png";